import { MutationTree, ActionTree } from 'vuex';
import { Font, Query } from '@/types';
import backend from '@/lib/backend';
import gql from 'graphql-tag';
import * as WebFont from 'webfontloader';

export interface FontsState {
  fonts: Font[];
}

export const namespaced = true;

WebFont.load({
  google: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    families: (window as any).$store.fonts.map((font) => font.name),
  },
});

export const state = (): FontsState => ({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fonts: (window as any).$store.fonts || [],
});

export const mutations: MutationTree<FontsState> = {
  setFonts(state: FontsState, fonts: Font[]): void {
    state.fonts = fonts;
    WebFont.load({
      google: {
        families: fonts.map((font) => font.name),
      },
    });
  },
};

export const actions: ActionTree<FontsState, FontsState> = {
  async all({ commit }) {
    const result = await backend.query<Query>({
      query: gql`
        {
          fonts {
            name
          }
        }
      `,
    });
    commit('setFonts', result.data.fonts);
  },
};
